"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
var _Actions = require("../../actions/Actions");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _selector = require("../../selectors/selector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CancelQuestion = function CancelQuestion(_ref) {
  var expirationDate = _ref.expirationDate,
    cancelApi = _ref.cancelApi,
    id = _ref.id,
    name = _ref.name;
  var dispatch = (0, _reactRedux.useDispatch)();
  var dateFormat = (0, _reactRedux.useSelector)(_selector.dateFormatSelector);
  var t = (0, _useTranslation.default)();
  var confirmCancelHandler = function confirmCancelHandler() {
    dispatch((0, _Actions.postCancelAddonRequest)(_objectSpread(_objectSpread({}, cancelApi), {}, {
      id: id
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    text: t('cancelAddon')
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 7,
      top: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    justify: "center",
    weight: 3,
    dataAttributes: {
      'data-testid': 'cancellationQuestion'
    }
  }, t('cancellationQuestion'), name, '?'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    },
    "data-testid": "cancellationMsg"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 1
  }, " ", t('cancellationMsg'), " "), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 4
  }, _r10CommonComponents.utils.formatDate(expirationDate, dateFormat))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center",
    disableFlex: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 8,
      left: 8,
      right: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    width: "full",
    text: t('confirm'),
    onClick: confirmCancelHandler,
    dataAttributes: {
      'data-testid': 'confirmButton'
    }
  })))));
};
CancelQuestion.propTypes = {
  expirationDate: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  cancelApi: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    endPoint: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = CancelQuestion;
exports.default = _default;